import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {theme} from '../../../../styles';
import trackAnalytics from '../../../../utils/gaia/trackAnalytics';

export default function DownloadApp({
    setStepCount,
    user,
    onExitOnboarding,
}: {
    setStepCount: SetState<number>;
    user: User;
    onExitOnboarding: () => void;
}) {
    return (
        <div>
            <Typography variant='h5' style={{marginTop: theme.spacing(2)}}>
                Start Exploring
            </Typography>
            <Typography variant='body1' style={{margin: theme.spacing(3)}}>
                Any item you save on the web will be synced to the app.{' '}
                {!user.hasMobileApp && 'Download the app and log in.'}
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    marginBottom: theme.spacing(4),
                }}
            >
                <a
                    href='https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4'
                    target='itunes_store'
                    className='hide-if-android'
                    onClick={() =>
                        trackAnalytics('Web Onboarding', {
                            label: 'Download iOS',
                        })
                    }
                >
                    <img
                        style={{height: 42}}
                        src='/static/img/appstore.svg'
                        alt='Download on the App Store'
                    />
                </a>
                <a
                    // eslint-disable-next-line max-len
                    href='https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en'
                    target='_blank'
                    className='hide-if-ios'
                    rel='noopener noreferrer'
                    onClick={() =>
                        trackAnalytics('Web Onboarding', {
                            label: 'Download Android',
                        })
                    }
                >
                    <img
                        style={{height: 42}}
                        src='/static/img/icons/play_badge.png'
                        alt='Get it on Google Play'
                    />
                </a>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    style={{fontSize: 14}}
                    onClick={() =>
                        setStepCount((prevState: number) => prevState - 1)
                    }
                >
                    Back
                </Button>
                <Button
                    color='primary'
                    variant='contained'
                    style={{fontSize: 14}}
                    onClick={() => {
                        onExitOnboarding();
                        trackAnalytics('Web Onboarding', {
                            label: 'Finished Onboarding',
                        });
                    }}
                >
                    Done
                </Button>
            </div>
        </div>
    );
}
